<template>
  <yandex-map
    v-if="coords && coords.length > 0"
    :settings="settings"
    :coords="map_position"
    :controls="['zoomControl','fullscreenControl','typeSelector','rulerControl']"
    :zoom="7"
  >
    <ymap-marker
      v-for="cord in coords"
      marker-id="1"
      :coords="[cord.latitude,cord.longitude]"
      :hint-content="hintTemplate(cord.company_name, cord.address)"
    />
  </yandex-map>
</template>

<script>

import { yandexMap, ymapMarker } from 'vue-yandex-maps'

export default {
  name: "Map",
  props: ["coords","map_position"],
  components: {
    yandexMap, ymapMarker
  },
  data() {
    return {
      settings: {
        lang: 'ru_RU',
      },
    }
  },
  methods: {
    hintTemplate(name,addr) {
      return `
        <h1 style="padding-bottom: 5px;">${name}</h1>
        <p> ${addr}</p>
      `
    }
  }
}

</script>
